<template>
      <div class="worksheetTypeDefinitionEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'worksheetTypeDefinition', params: {} }">
          Worksheet Type
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'worksheetTypeDefinitionEdit', params:{id: id} }">
            Edit Worksheet Type
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Worksheet Type Definition</v-card-title>
          <v-card-text>
            <worksheetTypeDefinition-form :id="id"></worksheetTypeDefinition-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import WorksheetTypeDefinitionForm from './WorksheetTypeDefinitionForm.vue';

    export default {
      name: 'worksheetTypeDefinition',
      data () {
        return {
          id: null
        }
      },
      components: {
        WorksheetTypeDefinitionForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    